<template>
  <v-dialog
    :value="show"
    :width="width"
    :max-width="maxWidth"
    persistent>
    <v-card :class="cardClasses" :flat="true">
      <v-card-title class="justify-space-between" :class="titleClasses">
        <template v-if="title">
          <h2>
            {{ title }}
          </h2>
        </template>
        <slot name="title"></slot>
      </v-card-title>
      <v-card-text class="pb-4" :style="`height: ${height}`">
        <slot name="content"></slot>
      </v-card-text>
      <v-card-actions class="pr-2 dialog-footer">
        <div v-if="stagingBtn" class="m-0 pl-2">
          <p id="see-staging" class="mb-0">{{stagingText}}</p>
          <div id="see-staging-div" @click="$emit('staging')">Ver</div>
        </div>
        <v-spacer />
        <v-btn flat color="black" @click="$emit('close')">
          Cerrar
        </v-btn>
        <v-btn
          flat
          v-if="saveButton"
          :disabled="disableSaveBtn"
          :loading="loading"
          class="k-orange-linear-text" @click="$emit('save')">
          {{ saveButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: 'auto',
    },
    width: {
      type: String,
      default: 'auto',
    },
    maxWidth: {
      type: String,
      default: '600px',
    },
    saveButton: {
      type: Boolean,
      default: true,
    },
    saveButtonText: {
      type: String,
      default: 'Guardar',
    },
    disableSaveBtn: {
      type: Boolean,
      default: false,
    },
    stagingBtn: {
      type: Boolean,
      default: false,
    },
    stagingText: {
      type: String,
      default: 'BLA BLA BLA',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    titleClasses: {
      type: Array,
      default: () => ([]),
    },
    cardClasses: {
      type: Array,
      default: () => (['pa-4']),
    },
  },
};
</script>

<style scoped>
#see-staging {
  font-size: 12px;
}
#see-staging-div {
  font-size: 12px;
  color: blue;
}
#see-staging-div:hover {
  cursor: pointer;
}
.dialog-footer {
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/global/DialogV2.vue